import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, forwardRef, useMemo } from 'react';
import { useContextProps } from 'react-aria-components';
import { Size } from '../../../constants/size.js';
import { twMerge } from '../../../utils/twMerge.js';
export const DescriptionListItemContext = createContext({});
export const DescriptionListItem = forwardRef(function DescriptionListItem(props, forwardedRef) {
    const [{ column = false, size = Size.Default, ...divProps }, ref] = useContextProps(props, forwardedRef, DescriptionListItemContext);
    const contextValue = useMemo(() => ({
        size,
        column,
    }), [size, column]);
    return (_jsx("div", { ...divProps, ref: ref, className: twMerge(`ppl-DescriptionListItem`, 'flex items-baseline', column ? 'flex-col' : 'flex-row gap-x-4', divProps.className), children: _jsx(DescriptionListItemContext.Provider, { value: contextValue, children: divProps.children }) }));
});
//# sourceMappingURL=DescriptionListItem.js.map